import styled from 'styled-components';
import { ReactComponent as NHSLogoAndText } from 'assets/nhs/ContinueWith_Original_LogoAndTextOnly.svg';

export const NHSLogoAndTextSVG = styled(NHSLogoAndText)`
  width: auto;
  display: block;
  margin: auto;
  height: ${({ isMobile }) => (isMobile ? '48px' : '59px')};
`;

const extraStyles = `
  border: 0;
`;

export default styled.button`
  color: #fff;
  text-decoration: none !important;
  display: block;
  border-radius: 4px;
  box-shadow: 0 4px 0 #003087;
  font-family: "Frutiger W01", Arial, Helvetica, sans-serif;
  background-color: #005eb8; 
  margin: 32px 0;
  ${extraStyles}
  
  &:hover, &:focus {
    background-color: #0153a1;
    color: #fff;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3pt #ffb81c;
  }
`;
